import Image from 'next/image'
import styles from './next-image.module.css'
import { BaseComponent, StoryblokImage } from '@cinch-nx/data-storyblok'
import { Property } from 'csstype'

interface NextImageProps extends BaseComponent {
  image: StoryblokImage
  alt: string
  height?: number
  borderRadius?: number
  quality?: number
  priority?: boolean
  fill?: boolean
  objectFit?: Property.ObjectFit
  objectPosition?: Property.ObjectPosition
}

export function NextImage({
  image,
  alt,
  height = 350,
  borderRadius = 22,
  quality,
  priority,
  fill = true,
  objectFit = 'cover',
  objectPosition = 'center',
}: NextImageProps) {
  return (
    <div className={styles.imageContainer} style={{ height: `${height}px` }}>
      <Image
        src={image.filename}
        alt={alt}
        quality={quality}
        priority={priority}
        fill={fill}
        style={{
          borderRadius: `${borderRadius}px`,
          objectFit: objectFit,
          objectPosition: objectPosition,
        }}
      />
    </div>
  )
}
